<div class="warning-inline" data-cy="mandatory-fields-inline">
  @if (hasIcon()) {
    <div class="warning-icon">
      <span data-cy="warning-icon" class="{{getIconClass()}}"></span>
    </div>
  }

  <div [ngClass]="getColorClass()" class="warning-messages">
    @if (warningInlineLabel) {
      <app-tooltip [dynamic]="false" [message]="warningInlineLabel" class="display-inline-flex">
        <span class="warning-message-text" data-cy="warning-inline-label">{{warningInlineLabel}}</span>
      </app-tooltip>
    }

    @if (warningInlineLabelsArray?.length === 1) {
      <span class="warning-message-text" data-cy="warning-inline-label">{{warningInlineLabelsArray[0]}}</span>
    }

    @if (warningInlineLabelsArray?.length > 1) {
      @for (warningLabel of warningInlineLabelsArray; track warningLabel; let index = $index) {
        <div class="warning-message-text"
        data-cy="warning-inline-label-list-item">{{index + 1}}. {{warningLabel}}</div>
      }
    }
  </div>
</div>
